export const getContainerStyles = (centered, zIndex) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  ...(centered && {
    position: 'fixed',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  }),
  ...(zIndex != null && { zIndex })
});

export const getCircularProgressStyles = (customColor) => {
  return customColor ? { color: customColor } : {};
};

export const labelStyles = {
  marginTop: 2
};
